/* eslint-disabled */

export default class MappingExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
